import type { CompanyId, GraphEdge, GraphNodeRef } from "../types";

export function getEdgeEndpointId(endpoint: GraphNodeRef): string {
  return typeof endpoint === "string" ? endpoint : endpoint.id;
}

export function getEdgeKey(
  edge: Pick<GraphEdge, "source" | "target" | "source_metric" | "target_metric">
): string {
  return [
    getEdgeEndpointId(edge.source),
    getEdgeEndpointId(edge.target),
    edge.source_metric,
    edge.target_metric,
  ].join("|");
}

export function formatMetricLabel(metric: string): string {
  if (metric.includes("_")) {
    // snake_case → Title Case
    return metric
      .split("_")
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(" ");
  }
  // PascalCase / camelCase (XBRL metric names) → "Words With Spaces"
  return metric
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/^./, (c) => c.toUpperCase());
}

export function formatDirection(direction: string): string {
  if (direction === "increased") return "Increased";
  if (direction === "decreased") return "Decreased";
  if (direction === "positive") return "Positive";
  if (direction === "negative") return "Negative";
  if (direction === "complex") return "Complex";
  return direction;
}

export function formatPercent(value: number): string {
  return `${Math.round(value * 100)}%`;
}

export function formatSignedMove(direction: string, pct: number): string {
  const arrow = direction === "decreased" ? "↓" : "↑";
  return `${arrow} ${pct.toFixed(1)}%`;
}

export function companyLabel(company: CompanyId | string): string {
  const labels: Record<string, string> = {
    apple: "Apple",
    nvidia: "NVIDIA",
    tsmc: "TSMC",
    google: "Alphabet",
    microsoft: "Microsoft",
  };

  return labels[company] ?? company;
}
